import { parseNumber, parseString } from './helpers'

export interface SaleInterface {
  sale_id?: string
  customer_id: string
  customer_code?: string
  customer_name?: string
  items: SaleItemInterface[]
}

export interface SaleResponseInterface {
  customer_id: string
  customer_code: string
  customer_name: string
  items: SaleItemInterface[]
}

export interface SaleItemInterface {
  product_id: string
  product_code?: string
  product_name?: string
  quantity: number
}

export function parseSale(
  response: SaleResponseInterface,
  saleId: string | undefined = undefined
): SaleInterface {
  const saleItems: SaleItemInterface[] = []

  if (Array.isArray(response.items) && response.items.length) {
    response.items.forEach((item) => {
      saleItems.push({
        product_id: parseString(item.product_id),
        product_code: parseString(item.product_code),
        product_name: parseString(item.product_name),
        quantity: parseNumber(item.quantity),
      })
    })
  }

  return {
    sale_id: saleId,
    customer_id: parseString(response.customer_id),
    customer_code: parseString(response.customer_code),
    customer_name: parseString(response.customer_name),
    items: saleItems,
  }
}
